module.exports = __webpack_public_path__ + "static/media/minusicon.e1315812.svg";